import { toBool } from 'utils/string';

//
// The organization settings the API sends in the login answer (globalDataCache.settings). The names are
// the API's SettingNames; a setting the client does not know is returned as its raw text.
//
export const AutoUserLicense = 'AutoUserLicense';
export const DefLanguageCode = 'DefLanguageCode';
export const OrgLanguageCodes = 'OrgLanguageCodes';
export const AIEnabled = 'AIEnabled';
//the display name of the AI assistant; empty means the localized default
export const AIAssistantName = 'AIAssistantName';

const boolSettings: string[] = [AutoUserLicense, AIEnabled];
const jsonSettings: string[] = [OrgLanguageCodes];

export class Settings {
  items: Setting[];

  constructor() {
    this.items = [];
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get(name: string): any {
    const setting = this.items.find((s) => s.settingName === name);

    return setting?.getValue();
  }

  clone(): Settings {
    const newSettings = new Settings();
    newSettings.items = this.items.map((s) => s.clone());

    return newSettings;
  }
}

export default class Setting {
  settingName: string;

  settingValue: string | undefined;

  constructor() {
    this.settingName = '';
    this.settingValue = undefined;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getValue(): any {
    if (boolSettings.includes(this.settingName)) {
      return toBool(this.settingValue);
    }

    if (jsonSettings.includes(this.settingName)) {
      if (!this.settingValue) return undefined;

      return JSON.parse(this.settingValue);
    }

    return this.settingValue;
  }

  clone(): Setting {
    const newSetting = new Setting();
    newSetting.settingName = this.settingName;
    newSetting.settingValue = this.settingValue;

    return newSetting;
  }
}
